function scrollBar() {
  $('.custom_values_wrapper').each(function (id, el) {
    var _el = $(el),
        pageTop = $(window).scrollTop(),
        pageBottom = pageTop + $(window).height(),
        elementTop = _el.offset().top - 150,
        elementBottom = elementTop + _el.height(),
        elementBottomNew = elementTop + 200,
        key = _el.attr('id');

        //PROGRESS INDICATIOR
        if (pageTop >= elementTop && pageTop <= elementBottom) {
          var elementHeight = _el.height();
          var totalScroll = -(elementTop - pageTop) / elementHeight * 100;
          $('.progress-item[data-key = ' + key + ']').css('width', totalScroll + '%');
        $('.progress-item[data-key = ' + key + ']').parents('.nav-anchors__item').addClass("is_active");
              $('.progress-item[data-key = ' + key + ']').parents('.nav-anchors__item').removeClass("is-disable");

        }
        if (pageTop < elementTop) {
          $('.progress-item[data-key = ' + key + ']').css('width', '0');
            $('.progress-item[data-key = ' + key + ']').parents('.nav-anchors__item').removeClass("is_active");
             $('.progress-item[data-key = ' + key + ']').parents('.nav-anchors__item').removeClass("is-disable");
        }
        if (pageTop > elementBottom) {
          $('.progress-item[data-key = ' + key + ']').css('width', '100%');
            $('.progress-item[data-key = ' + key + ']').parents('.nav-anchors__item').addClass("is-disable");
        }
  });
}
$(document).ready(function(){
  var $temp = $("<input>");
var $url = $(location).attr('href');
$('.copy_clippad').on('click', function() {
  $("body").append($temp);
  $temp.val($url).select();
  document.execCommand("copy");
  $temp.remove();
});

  scrollBar();
  $(window).on('scroll', function() {
    scrollBar();
  });
$('.custome_tabs_wrapper li.nav-anchors__item a').click(function (e) {
  e.preventDefault();
    var data_link = $(this).attr("data-id");
   var header_height = $("header#SiteHeader").height();
     $('html, body').animate({
        scrollTop: $(".custom_values_wrapper.part[data-id='"+data_link+"']").offset().top  - header_height
    }, 1200);
});
  
});